import { useMemo } from 'react';
export default ((dropdownProps, groupedItems) => {
  const {
    selectedItem,
    defaultSelectedItem,
    initialSelectedItem
  } = dropdownProps;
  return useMemo(() => {
    const getSelectedItem = itemToFind => {
      return groupedItems.flatMap(groups => groups.items).find(i => i.value === itemToFind.value) || null;
    };
    if (selectedItem) {
      return {
        selectedItem: getSelectedItem(selectedItem)
      };
    }
    if (defaultSelectedItem) {
      return {
        defaultSelectedItem: getSelectedItem(defaultSelectedItem)
      };
    }
    if (initialSelectedItem) {
      return {
        initialSelectedItem: getSelectedItem(initialSelectedItem)
      };
    }
    return {};
  }, [selectedItem, defaultSelectedItem, initialSelectedItem, groupedItems]);
});
//# sourceMappingURL=useSelectedItem.js.map